export const UNITS = {
    density: 'kg/m3',
    weight: 'kg',
    length: 'm',
    thickness: 'm',
    viscosity: 'Pa*s',
    ph: '',
    brinell: 'kg_f/mm^2',
    thermalConductivity: 'W/(cm °C)',
    meltingPoint: '°C',
    specificHeat: '°C',
    from: '',
    equal: '',
    defined: '',
}
